import telemetry from '@/utils/telemetry';

export default {
  install(Vue) {
    /* eslint-disable-next-line no-param-reassign */
    Vue.prototype.$telemetrySetContext = function setContext(params) {
      telemetry.setContext(this.$store.state.g2wEnv.current, params);
    };

    /* eslint-disable-next-line no-param-reassign */
    Vue.prototype.$telemetryTrack = function track(event, context) {
      telemetry.track(this.$store.state.g2wEnv.current, event, context);
    };
  }
};
